/**
 * LoadingSpinner 컴포넌트
 *
 * 검색 중 로딩 상태 표시
 */

interface LoadingSpinnerProps {
  /** 제목 */
  title: string
  /** 설명 */
  description: string
}

export function LoadingSpinner({ title, description }: LoadingSpinnerProps) {
  return (
    <div className="text-center py-12">
      <div className="w-16 h-16 mx-auto mb-6">
        <div className="w-full h-full border-4 border-accent-500 border-t-transparent rounded-full animate-spin" />
      </div>
      <h2 className="text-xl font-semibold text-text-primary mb-2">{title}</h2>
      <p className="text-text-secondary">{description}</p>
    </div>
  )
}
